import type {USER_BASE_INFO} from 'src/types/crm';

import {useSelector} from 'react-redux';
import {useTRMEnabled, useCrmRedesignedEnabled} from 'src/hooks/product-flags';
import useAgencyConfig from 'src/hooks/useAgencyConfig';
import {selectUserInfo} from 'src/selectors/crm';


export function useTrmUserInfo(): USER_BASE_INFO | null {
  const trmEnabled = useTRMEnabled();
  const userInfo = useSelector(selectUserInfo);

  return trmEnabled ? userInfo : null;
}

export const useCRMMigrationEnabled = (): boolean => {
  const crmRedesignedEnabled = useCrmRedesignedEnabled();
  return crmRedesignedEnabled;
};

// Note[Arush]: To be used inside the CRM existing pages only,
// for Enabling/Disabling Conversational flows, such as Quick &
// Prompt filters, AI summary for Applicant and new Tasks flow.
export const useNewConversationalCRMFlowEnabled = (): boolean => {
  const voiceAiEnabled = Boolean(useAgencyConfig('voiceAiEnabled'));
  return useCRMMigrationEnabled() && voiceAiEnabled;
};
